import * as auth from '../../app/modules/auth/redux/AuthRedux'

export default function setupAxios(axios: any, store: any) {
  let redirectingToLogin = false

  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      const accessToken = store.getState()?.auth?.accessToken

      if (error?.response?.status === 401 && accessToken && !redirectingToLogin) {
        redirectingToLogin = true
        store.dispatch(auth.actions.logout())
        localStorage.removeItem('persist:isg-next-auth')

        const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
        window.location.assign(`${publicUrl}/auth/login`)
      }

      return Promise.reject(error)
    }
  )
}
